import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { PRESENCE_STATES as t, PRESENCE_STATES_LIST as n } from "./presence-constants.js";
import { createCommentVNode as r, createElementBlock as i, createElementVNode as a, normalizeClass as o, openBlock as s, toDisplayString as c } from "vue";
//#region components/presence/presence.vue
var l = {
	compatConfig: { MODE: 3 },
	name: "DtPresence",
	props: {
		presence: {
			type: String,
			default: t.ACTIVE,
			validator: (e) => n.includes(e)
		},
		srText: {
			type: String,
			default: null
		}
	}
}, u = ["aria-live"], d = {
	key: 0,
	"data-qa": "dt-presence-sr-text",
	class: "sr-only"
};
function f(e, t, n, l, f, p) {
	return s(), i("div", {
		class: "d-presence",
		"data-qa": "dt-presence",
		role: "status",
		"aria-live": e.$attrs.ariaLive || "off"
	}, [n.srText ? (s(), i("span", d, c(n.srText), 1)) : r("", !0), a("div", { class: o(["d-presence__inner", {
		"d-presence__inner--active": n.presence === "active",
		"d-presence__inner--away": n.presence === "away",
		"d-presence__inner--busy": n.presence === "busy",
		"d-presence__inner--offline": n.presence === "offline"
	}]) }, null, 2)], 8, u);
}
var p = /* @__PURE__ */ e(l, [["render", f]]);
//#endregion
export { p as default };

//# sourceMappingURL=presence.js.map